import { render, staticRenderFns } from "./DashboardWidgetROS.vue?vue&type=template&id=62e53c42&"
import script from "./DashboardWidgetROS.vue?vue&type=script&lang=js&"
export * from "./DashboardWidgetROS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports